import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { TasksReportMacroRendererProps } from '../src/TasksReportMacroRenderer.tsx';

export const TasksReportMacroHandler: LoadableType<TasksReportMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TasksReportMacro" */ '../src/TasksReportMacroRenderer.tsx'
			)
		).TasksReportMacroRenderer,
});
